import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseAnpReportsProps<T> = {
  filters?: {
    page?: number;
  };
  mapper?: (data: any) => T,
};

export const useAnpReports = <T,>({
  filters: { page } = {},
  mapper = Mapper.default<T>(),
}: UseAnpReportsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['anpReports', page],
    queryFn: () => {
      return privateAxios.get(`/anp/reports`, {
        params: {
          page,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
